import React, { useEffect } from "react";
import { Card, GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Button } from "@progress/kendo-react-buttons";
import { Typography } from "@progress/kendo-react-common";
import { Field, FieldArrayRenderProps } from "@progress/kendo-react-form";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import FormTextField from "../../components/formFields/FormTextField";
import { MdDelete } from "react-icons/md";
import IconButton from "../../components/common/IconButton";
import { setBankDeleteIndex } from "./agentSlice";

const BankArray = (fieldArrayRenderProps: FieldArrayRenderProps) => {
  const contactDeleteIndex = useAppSelector((state) => state.agent.deleteIndex);
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const dispatch = useAppDispatch();

  const name = fieldArrayRenderProps.name || "";

  useEffect(() => {
    return () => {
      dispatch(closeDialog());
    };
  }, []);

  const handleOpenDeleteDialog = (index: number) => {
    dispatch(openDialog("bankDeleteDialog"));
    dispatch(setBankDeleteIndex(index));
  };

  const handleDeleteAction = React.useCallback(
    (index: number) => {
      fieldArrayRenderProps.onRemove({ index: index });
      dispatch(closeDialog());
      dispatch(setBankDeleteIndex(-1));
    },
    [fieldArrayRenderProps]
  );

  const pushElementInarray = React.useCallback(() => {
    fieldArrayRenderProps.onPush({
      value: {
        BankName: "",
        BranchName: "",
        AccountNo: "",
        IFSCCode: "",
      },
    });
  }, [fieldArrayRenderProps]);

  return (
    <GridLayout cols={[{ width: "100%" }]}>
      {fieldArrayRenderProps.value && fieldArrayRenderProps.value.length === 0
        ? pushElementInarray()
        : null}
      <GridLayoutItem style={{ marginBottom: 10 }}>
        <Button
          fillMode={"solid"}
          themeColor={"primary"}
          onClick={pushElementInarray}
          type="button"
        >
          Add Bank
        </Button>
      </GridLayoutItem>
      {dialogName === "bankDeleteDialog" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Bank"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(contactDeleteIndex)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
      {fieldArrayRenderProps.value &&
        fieldArrayRenderProps.value.length > 0 &&
        fieldArrayRenderProps.value.map((Bank: any, index: number) => (
          <GridLayoutItem key={index}>
            <Card className="fieldarray-card">
              <GridLayout
                style={{ marginRight: 40 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[
                  { width: "24%" },
                  { width: "24%" },
                  { width: "24%" },
                  { width: "24%" },
                  { width: "4%" },
                ]}
              >
                <GridLayoutItem>
                  <Field
                    name={`${name}.${index}.BankName`}
                    label="Bank Name"
                    placeholder="i.e HDFC Bank"
                    component={FormTextField}
                  />
                </GridLayoutItem>

                <GridLayoutItem>
                  <Field
                    name={`${name}.${index}.BranchName`}
                    label="Branch Name"
                    placeholder="Branch Name"
                    component={FormTextField}
                  />
                </GridLayoutItem>

                <GridLayoutItem>
                  <Field
                    name={`${name}.${index}.AccountNo`}
                    label="Account No"
                    placeholder="Account No"
                    component={FormTextField}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name={`${name}.${index}.IFSCCode`}
                    label="IFSCCode"
                    placeholder="IFSCCode"
                    component={FormTextField}
                  />
                </GridLayoutItem>
                <GridLayoutItem
                  style={{
                    textAlign: "right",
                    position: "relative",
                  }}
                >
                  <IconButton
                    onClick={() => handleOpenDeleteDialog(index)}
                    // disabled={fieldArrayRenderProps.value.length === 1}
                    themeColor={"error"}
                    size={"large"}
                    fillMode={"solid"}
                    type="button"
                    style={{
                      position: "absolute",
                      top: 37,
                      right: 0,
                      height: 24,
                      width: 24,
                    }}
                    icon={MdDelete}
                    iconClassName="absolute-position"
                    iconStyle={{ fontSize: "24px" }}
                  />
                </GridLayoutItem>
              </GridLayout>
            </Card>
          </GridLayoutItem>
        ))}
    </GridLayout>
  );
};

export default BankArray;
